import React from 'react';
import { Document, Page, Text, View, StyleSheet, Font, Image } from '@react-pdf/renderer';
import logo from '../assets/LOGO2MPSERVICESSANSSLOGAN.png';

// Register a font that supports French characters
Font.register({
  family: 'Helvetica',
  src: 'https://fonts.googleapis.com/css2?family=Roboto:wght@400;700&display=swap'
});

const styles = StyleSheet.create({
  page: {
    flexDirection: 'column',
    backgroundColor: '#FFFFFF',
    padding: 30,
    fontSize: 12,
    fontFamily: 'Helvetica',
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 30,
    borderBottom: '2px solid #0066cc',
    paddingBottom: 20,
  },
  logo: {
    width: 120,
    height: 80,
  },
  title: {
    fontSize: 24,
    fontWeight: 'bold',
    textAlign: 'center',
    color: '#0066cc',
  },
  section: {
    marginBottom: 20,
  },
  sectionTitle: {
    fontSize: 16,
    fontWeight: 'bold',
    marginBottom: 10,
    color: '#333',
    borderBottom: '1px solid #ddd',
    paddingBottom: 5,
  },
  row: {
    flexDirection: 'row',
    marginBottom: 8,
  },
  label: {
    width: 120,
    fontWeight: 'bold',
    color: '#555',
  },
  value: {
    flex: 1,
    color: '#333',
  },
  footer: {
    position: 'absolute',
    bottom: 30,
    left: 30,
    right: 30,
    borderTop: '1px solid #ddd',
    paddingTop: 10,
    flexDirection: 'row',
    justifyContent: 'space-between',
    fontSize: 10,
    color: '#666',
  },
  valid: {
    backgroundColor: '#e8f5e8',
    padding: 10,
    borderRadius: 5,
    marginTop: 20,
    textAlign: 'center',
  },
  validText: {
    color: '#2e7d32',
    fontWeight: 'bold',
  }
});

const MissionPDF = ({ data }) => {
  const formatDate = (dateString) => {
    if (!dateString) return '';
    return new Date(dateString).toLocaleDateString('fr-FR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  };

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        {/* Header */}
        <View style={styles.header}>
          <Image src={logo} style={styles.logo} />
          <Text style={styles.title}>ORDRE DE MISSION</Text>
          <View />
        </View>

        {/* Mission Information */}
        <View style={styles.section}>
          <Text style={styles.sectionTitle}>Informations de la Mission</Text>
          <View style={styles.row}>
            <Text style={styles.label}>Num�ro:</Text>
            <Text style={styles.value}>{data.order_number || "#"}</Text>
          </View>
          <View style={styles.row}>
            <Text style={styles.label}>Date de cr�ation:</Text>
            <Text style={styles.value}>{formatDate(data.createdAt)}</Text>
          </View>
          <View style={styles.row}>
            <Text style={styles.label}>P�riode:</Text>
            <Text style={styles.value}>
              Du {formatDate(data.validity_from)} au {formatDate(data.validity_to)}
            </Text>
          </View>
          <View style={styles.row}>
            <Text style={styles.label}>Motif:</Text>
            <Text style={styles.value}>{data.reason}</Text>
          </View>
        </View>

        {/* Employee Information */}
        <View style={styles.section}>
          <Text style={styles.sectionTitle}>Informations de l'Employ�</Text>
          {data.employee && (
            <>
              <View style={styles.row}>
                <Text style={styles.label}>Nom:</Text>
                <Text style={styles.value}>
                  {data.employee.first_name} {data.employee.last_name}
                </Text>
              </View>
              <View style={styles.row}>
                <Text style={styles.label}>ID:</Text>
                <Text style={styles.value}>{data.employee.id}</Text>
              </View>
            </>
          )}
        </View>

        {/* Transport Information */}
        <View style={styles.section}>
          <Text style={styles.sectionTitle}>Informations de Transport</Text>
          {data.transport && (
            <>
              <View style={styles.row}>
                <Text style={styles.label}>Type:</Text>
                <Text style={styles.value}>{data.transport.type}</Text>
              </View>
              {data.transport.type === 'personnel' && (
                <>
                  <View style={styles.row}>
                    <Text style={styles.label}>Marque:</Text>
                    <Text style={styles.value}>{data.transport.brand}</Text>
                  </View>
                  <View style={styles.row}>
                    <Text style={styles.label}>Mod�le:</Text>
                    <Text style={styles.value}>{data.transport.model}</Text>
                  </View>
                  <View style={styles.row}>
                    <Text style={styles.label}>Immatriculation:</Text>
                    <Text style={styles.value}>{data.transport.registration}</Text>
                  </View>
                </>
              )}
            </>
          )}
        </View>

        {/* Validation Information */}
        {data.validated && (
          <View style={styles.section}>
            <Text style={styles.sectionTitle}>Validation</Text>
            <View style={styles.row}>
              <Text style={styles.label}>Valid� par:</Text>
              <Text style={styles.value}>
                {data.validator ? data.validator.username : 'Admin'}
              </Text>
            </View>
            <View style={styles.row}>
              <Text style={styles.label}>Date de validation:</Text>
              <Text style={styles.value}>{formatDate(data.validated_at)}</Text>
            </View>
          </View>
        )}

        {/* Report */}
        {data.rapport && (
          <View style={styles.section}>
            <Text style={styles.sectionTitle}>Rapport de Mission</Text>
            <Text style={styles.value}>{data.rapport}</Text>
          </View>
        )}

        {/* Validation Stamp */}
        {data.validated && (
          <View style={styles.valid}>
            <Text style={styles.validText}>VALID�</Text>
            <Text style={styles.validText}>Le {formatDate(data.validated_at)}</Text>
          </View>
        )}

        {/* Footer */}
        <View style={styles.footer}>
          <Text>2MP SERVICES - D�partement RH</Text>
          <Text>G�n�r� le {formatDate(new Date())}</Text>
        </View>
      </Page>
    </Document>
  );
};

export default MissionPDF;
